import Model, { attr } from '@ember-data/model';

export default class RefundModel extends Model {
  @attr('number') amount!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    refund: RefundModel;
  }
}
